export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: 'ID',
      prop: 'id',
      sortable: true
    },
    {
      label: '分类',
      prop: 'category',
      search: true,
      searchPlaceholder: '请输入'
    },
    {
      label: '问题',
      prop: 'content',
      search: true,
      searchPlaceholder: '请输入'
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      sortable: true
    }
  ]
}
